import { render, staticRenderFns } from "./OrderSelect.vue?vue&type=template&id=1af41633&scoped=true"
import script from "./OrderSelect.vue?vue&type=script&lang=ts"
export * from "./OrderSelect.vue?vue&type=script&lang=ts"
import style0 from "./OrderSelect.vue?vue&type=style&index=0&id=1af41633&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af41633",
  null
  
)

export default component.exports